import type { JSX } from 'react';
import type { PatientPresence } from '@common/customControls/bariatrics';
import { FormGroupBadge } from '@frontend/components/fields/FormGroupBadge';
import { patientPresenceWithColor } from '@frontend/components/pages/episodeCategory/customControls/bariPre/bariPreGroupSession/bariPreGroupSessionUtils';

export function PatientPresenceFormGroup(props: { presence: PatientPresence | null }): JSX.Element {
    return (
        <FormGroupBadge
            label="Aanwezigheid"
            options={patientPresenceWithColor}
            value={props.presence}
        />
    );
}
